import { render } from "./header.vue?vue&type=template&id=1df8671f"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=1df8671f&lang=css"

import exportComponent from "D:\\wwwroot\\vant\\lan_v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__